import { useSession, signOut } from 'next-auth/react';
import { useRouter } from 'next/navigation';

import { useAgeConfirmationStore } from '@/features/age-verification/store/age-confirmation.store';
import { invalidateSellerProfileCache } from '@/features/original-sale';

export const useAuth = () => {
  const { data: session, status } = useSession();
  const router = useRouter();
  const clearSessionConfirmation = useAgeConfirmationStore(
    (state) => state.clearSessionConfirmation,
  );

  const isInitialized = status !== 'loading';

  const logout = async () => {
    clearSessionConfirmation();
    invalidateSellerProfileCache();
    await signOut({ redirect: false });
    router.refresh();
  };

  return {
    user: session?.user,
    isAuthenticated: status === 'authenticated',
    isLoading: status === 'loading',
    isUnauthenticated: status === 'unauthenticated',
    isInitialized,
    logout,
    session,
    status,
  };
};
